import { Controller } from '@hotwired/stimulus'

// Support turning snap scroll on/off with turbo
// See snap-scroll.scss for more details
export default class extends Controller {
    connect() {
        // Only purpose is to set the data attribute on the html tag
        // lets use get around a shared layout file where this
        // behaviour is defined in a child element in yield
        document.documentElement.setAttribute('data-snap-scroll', '')
    }

    disconnect() {
        document.documentElement.removeAttribute('data-snap-scroll')
    }
}
